'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSmallColumnHeight = exports.shouldSetSmallColumnHeight = exports.defaultFilter = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.parseQueryToFilter = parseQueryToFilter;
exports.parseFilterToQuery = parseFilterToQuery;
exports.parseDestinations = parseDestinations;
exports.parseActivities = parseActivities;
exports.matchTextToFilter = matchTextToFilter;
exports.checkEqual = checkEqual;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _levenshteinEditDistance = require('levenshtein-edit-distance');

var _levenshteinEditDistance2 = _interopRequireDefault(_levenshteinEditDistance);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');


var perPage = 10;

function parseQueryToFilter(query) {
  var filter = {
    activities: [],
    languages: ['Any'],
    price_condition: [],
    duration: [],
    other: [],
    sort: 'Recommended',
    starting_time: [],
    instant_booking: '',
    is_include: true,
    is_hotel_pickup: false,
    is_private_car: false,
    price_range: [0, 5000],
    limit: 10,
    location: '',
    text: '',
    raw_keyword: '',
    click_suggest: false,
    skip: 0,
    session_id: '',
    date: null,
    is_flexible_date: false,
    is_instant: false,
    // tags: [],
    tags: ['tour_lx']
  };
  if (query.sort) {
    filter.sort = query.sort;
  }
  if (query.text) {
    filter.text = query.text;
  }
  if (query.raw_keyword) {
    filter.raw_keyword = query.raw_keyword;
  }
  if (query.page && parseInt(query.page, 10) !== 1) {
    filter.skip = (parseInt(query.page, 10) - 1) * 10;
  }
  if (query.instant_booking) {
    if (query.instant_booking === 'Custom date') {
      if (query.from && query.to) {
        filter.instant_booking = query.instant_booking;
        filter.from = (0, _momentTimezone2.default)(query.from).toDate();
        filter.to = (0, _momentTimezone2.default)(query.to).toDate();
      }
    } else {
      filter.instant_booking = query.instant_booking;
    }
  }
  if (query.quantity) {
    filter.quantity = parseInt(query.quantity, 10);
  }
  if (query.languages) {
    filter.languages = [query.languages];
  }
  if (query.date) {
    if (query.date === 'today') {
      filter.date = (0, _momentTimezone2.default)().startOf('d').toISOString();
    } else if (query.date === 'tomorrow') {
      filter.date = (0, _momentTimezone2.default)().startOf('d').add(1, 'd').toISOString();
    } else {
      filter.date = (0, _momentTimezone2.default)(query.date, 'DD-MM-YYYY').toISOString();
    }
  }
  if (query.is_instant === 'true') {
    filter.is_instant = true;
  }
  if (query.is_include) {
    filter.is_include = true;
  }
  if (query.is_hotel_pickup) {
    filter.is_hotel_pickup = true;
  }
  if (query.is_private_car) {
    filter.is_private_car = true;
  }
  if (query.is_flexible_date) {
    filter.is_flexible_date = true;
  }
  filter.location = query.location === 'Any' ? '' : query.location;
  // if (query.location && query.location !== 'Any') {
  // filter.location = query.location;
  // }
  if (query.activities) {
    filter.activities = query.activities.split(',');
  }
  if (query.tags) {
    filter.tags = query.tags.split(',');
  }
  if (query.price_range) {
    filter.price_range = query.price_range.split('-').map(function (p) {
      return parseInt(p, 10);
    });
  }
  if (query.price_condition) {
    filter.price_condition = query.price_condition.split(',');
  }
  if (query.other) {
    filter.other = query.other.split(',');
  }
  if (query.duration) {
    filter.duration = query.duration.split(',');
  }
  if (query.starting_time) {
    filter.starting_time = query.starting_time.split(',');
  }
  if (query.session_id) {
    filter.session_id = query.session_id;
  }
  if (query.click_suggest === 'true') {
    filter.click_suggest = true;
  }
  return filter;
}

function parseFilterToQuery(filter) {
  var base = '/search/';
  // let base = '/search';
  var query = [];
  // if (filter.location) {
  // base += filter.location;
  // query.push(`location=${filter.location}`);
  // }
  base += filter.location || 'Any';
  if (filter.text) {
    // base += filter.text;
    query.push('text=' + encodeURIComponent(filter.text));
  }
  if (filter.skip && filter.skip !== 0) {
    query.push('page=' + (Math.ceil(filter.skip / perPage) + 1));
  }
  // if (filter.raw_keyword) {
  //   query.push(`raw_keyword=${escape(filter.raw_keyword)}`);
  // }
  // if (filter.click_suggest) {
  //   query.push('click_suggest=true');
  // }
  if (filter.sort && filter.sort !== 'Recommended') {
    query.push('sort=' + filter.sort);
  }
  if (filter.date) {
    var dayDiff = (0, _momentTimezone2.default)(filter.date).diff((0, _momentTimezone2.default)().startOf('day'), 'day');
    if (dayDiff === 0) {
      query.push('date=today');
    } else if (dayDiff === 1) {
      query.push('date=tomorrow');
    } else {
      query.push('date=' + (0, _momentTimezone2.default)(filter.date).format('DD-MM-YYYY'));
    }
  }
  if (filter.is_instant) {
    query.push('is_instant=true');
  }
  if (filter.activities && filter.activities.length > 0) {
    query.push('activities=' + filter.activities.map(function (act) {
      return encodeURIComponent(act);
    }).join(','));
  }
  if (filter.tags && filter.tags.length > 0) {
    if (!(filter.tags.length === 1 && filter.tags[0] === 'tour_lx')) {
      query.push('tags=' + filter.tags.map(function (tag) {
        return encodeURIComponent(tag);
      }).join(','));
    }
  }
  if (filter.quantity && filter.quantity !== 2) {
    query.push('quantity=' + filter.quantity);
  }
  if (filter.is_include === false) {
    query.push('is_include=' + filter.is_include);
  }
  if (filter.is_flexible_date) {
    query.push('is_flexible_date=' + filter.is_flexible_date);
  }
  if (filter.is_hotel_pickup) {
    query.push('is_hotel_pickup=' + filter.is_hotel_pickup);
  }
  if (filter.is_private_car) {
    query.push('is_private_car=' + filter.is_private_car);
  }
  if (filter.languages && filter.languages.length > 0) {
    if (filter.languages[0] !== 'Any') {
      query.push('languages=' + filter.languages[0]);
    }
  }
  if (filter.price_range && filter.price_range.length === 2) {
    if (filter.price_range[0] !== 0 || filter.price_range[1] !== 5000) {
      query.push('price_range=' + filter.price_range[0] + '-' + filter.price_range[1]);
    }
  }
  if (filter.price_condition && filter.price_condition.length > 0) {
    query.push('price_condition=' + filter.price_condition.join(','));
  }
  if (filter.starting_time && filter.starting_time.length > 0) {
    query.push('starting_time=' + filter.starting_time.join(','));
  }
  if (filter.duration && filter.duration.length > 0) {
    query.push('duration=' + filter.duration.map(function (dur) {
      return encodeURIComponent(dur);
    }).join(','));
  }
  if (query.length > 0) {
    base += '?' + query.join('&');
  }
  return base;
}

function parseDestinations(destinations) {
  var cities = [];
  (0, _keys2.default)(destinations).map(function (key) {
    destinations[key].map(function (city) {
      cities.push(city.city);
    });
  });
  return cities;
}

function parseActivities(activities) {
  var returnActivities = [];
  activities.map(function (act) {
    act.children.map(function (child) {
      returnActivities.push(child);
    });
  });
  return returnActivities;
}

function matchTextToFilter(filter, destinations, activities, keywords) {
  // filter.raw_keyword = filter.text;
  if (filter.text) {
    filter.sort = 'Most relevant';
    if (filter.text.length >= 3) {
      var minDistance = 999;
      var nearestWord = '';
      var minThreshold = Math.ceil(filter.text.length * 0.2);
      keywords.map(function (key) {
        var distance = (0, _levenshteinEditDistance2.default)(key, filter.text, true);
        if (distance <= minThreshold && distance < minDistance) {
          minDistance = distance;
          nearestWord = key;
        }
      });
      if (nearestWord) {
        filter.text = nearestWord;
      }
    }
    destinations.map(function (city) {
      if (filter.text.toLowerCase() === city.toLowerCase()) {
        filter.location = city;
        filter.text = '';
        filter.sort = 'Recommended';
      }
    });
    activities.map(function (act) {
      if (filter.text.toLowerCase() === act.toLowerCase()) {
        if (filter.activities.indexOf(act) < 0) {
          filter.activities.push(act);
        }
        filter.text = '';
        filter.sort = 'Recommended';
      }
    });
  }
  return filter;
}

function checkEqual(filter, filter2) {
  if (_lodash2.default.isEqual(
  // {...filter, skip: 0, limit: 10, raw_keyword: '', session_id: '', click_suggest: false},
  (0, _extends3.default)({}, filter, { limit: 10, raw_keyword: '', session_id: '', click_suggest: false }), (0, _extends3.default)({}, filter2, { raw_keyword: '', session_id: '', click_suggest: false }))) {
    return true;
  }
  return false;
}

var defaultFilter = exports.defaultFilter = {
  activities: [],
  languages: ['Any'],
  price_condition: [],
  duration: [],
  other: [],
  tags: [],
  sort: 'Recommended',
  starting_time: [],
  instant_booking: '',
  is_include: true,
  is_hotel_pickup: false,
  is_private_car: false,
  price_range: [0, 5000],
  limit: 10,
  location: '',
  date: null,
  is_flexible_date: false,
  text: '',
  raw_keyword: '',
  click_suggest: false,
  skip: 0,
  session_id: '',
  is_instant: false,
  quantity: 2
};

var getSmallColumnByKey = function getSmallColumnByKey(key) {
  return function () {
    if (!window || !window.document) return { should: false, height: '100%' }[key];
    var footer = window.document.getElementById('app-footer');
    if (!footer) return { should: false, height: '100%' }[key];
    // if ((window.innerHeight - footer.getBoundingClientRect().top) > 0 && footer.getBoundingClientRect().top > 67) {
    if (window.innerHeight - footer.getBoundingClientRect().top > 0) {
      return {
        should: true,
        height: window.innerHeight - (window.innerHeight - footer.getBoundingClientRect().top) + 'px'
      }[key];
    }
    return { should: false, height: '100%' }[key];
  };
};

var shouldSetSmallColumnHeight = exports.shouldSetSmallColumnHeight = getSmallColumnByKey('should');
var getSmallColumnHeight = exports.getSmallColumnHeight = getSmallColumnByKey('height');


//////////////////
// WEBPACK FOOTER
// ./src/utils/search.js
// module id = 198
// module chunks = 47